export const getHashFromIpfsUrl = (ipfsPath) => {
  return ipfsPath.replace("ipfs://ipfs/", "");
};
